require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconGift.tsx
var IconGift_exports = {};
__export(IconGift_exports, {
  default: () => IconGift_default
});
module.exports = __toCommonJS(IconGift_exports);

// src/assets/monochrome/gift.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgGift = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.61756 1.33598C5.27971 1.33598 4.19147 2.42422 4.19147 3.76207C4.19147 4.11329 4.26591 4.44752 4.39976 4.74937H1.72126C1.32395 4.74937 1.00195 5.07137 1.00195 5.46867V9.45117C1.00195 9.84847 1.32395 10.1705 1.72126 10.1705H2.14015V17.9449C2.14015 18.3422 2.46215 18.6642 2.85945 18.6642H17.164C17.5613 18.6642 17.8833 18.3422 17.8833 17.9449V10.1705H18.2811C18.6784 10.1705 19.0004 9.84866 19.0004 9.45117V5.46868C19.0005 5.07137 18.6785 4.74937 18.2812 4.74937H15.6223C15.7562 4.44753 15.8306 4.11332 15.8306 3.76211C15.8307 2.42422 14.7424 1.33598 13.4045 1.33598C11.6896 1.33598 10.6195 2.55845 10.0111 3.62823C9.40259 2.55845 8.3325 1.33598 6.61756 1.33598ZM5.63012 3.76207C5.63012 3.22795 6.08348 2.77459 6.6176 2.77459C7.24664 2.77459 7.75434 3.08349 8.15683 3.50865C8.51353 3.88545 8.78192 4.34807 8.9707 4.74937H6.57772C6.04588 4.73917 5.63012 4.31202 5.63012 3.76207ZM13.4444 4.74937H11.0486C11.2361 4.34808 11.5035 3.88544 11.8602 3.50866C12.2625 3.08367 12.7716 2.77462 13.4048 2.77462C13.9389 2.77462 14.3923 3.22799 14.3923 3.76211C14.3922 4.31201 13.9765 4.73917 13.4444 4.74937ZM2.44059 8.73207V6.18821H9.29206V8.73207H2.44059ZM10.7307 8.73207V6.18821H17.5619V8.73207H10.7307ZM3.57879 17.2256V10.1705H9.29206V17.2256H3.57879ZM10.7307 17.2256V10.1705H16.4446V17.2256H10.7307Z", fill: "#818898" }) });
var gift_default = SvgGift;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconGift.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconGift = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(gift_default, {}) });
};
IconGift.displayName = "IconGift";
var IconGift_default = IconGift;
